import * as Styled from './ContentWrapper.styles';

const ContentWrapper = ({ children }) => {
  return <Styled.ContentWrapper>{children}</Styled.ContentWrapper>;
};

export default ContentWrapper;
